import React from "react";

export const SubNavContext = React.createContext({
    SubNav: [],
    setSubNav: (SubNav: any) => {}
});

export default SubNavContext